import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { useParams, useHistory } from 'react-router-dom'
import { Box, Button, Typography, CircularProgress } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import ChecklistCard from './ChecklistCard'
import KickoffCard from './KickoffCard'
import AspireHandoffCard from './AspireHandoffCard'

const SECTIONS = [
  { key: 'permits', title: 'Permits' },
  { key: 'submittals', title: 'Submittals' },
  { key: 'materialSourcing', title: 'Material Sourcing' }
]

const PostCloseView = (props) => {
  const { projectId } = useParams()
  const history = useHistory()
  const { url } = props
  const [planning, setPlanning] = React.useState(null)
  const [project, setProject] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState('')

  React.useEffect(() => {
    setLoading(true)
    axios.get(`${url}/api/bid-estimation/projects/${projectId}/post-close`).then(res => {
      setPlanning(res.data.planning)
      setProject(res.data.project)
      setLoading(false)
    }).catch(err => {
      setLoading(false)
      if (err.response?.status === 403) {
        setError('This project is not yet won. Post-close planning is available after marking the project as won.')
      } else {
        setError(err.response?.data?.error || 'Failed to load post-close planning')
      }
    })
  }, [projectId])

  const handleUpdate = (updatedPlanning) => {
    setPlanning(updatedPlanning)
  }

  if (loading) {
    return (
      <div style={{ backgroundColor: '#fafafa', minHeight: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 40 }}>
        <CircularProgress />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ backgroundColor: '#fafafa', minHeight: '100%' }}>
        <Box style={{ backgroundColor: '#2e7d32', color: '#fff', padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button size="small" startIcon={<ArrowBack />}
            onClick={() => history.push(`/bid-estimation/${projectId}`)}
            style={{ color: '#fff', textTransform: 'none' }}>Back</Button>
          <Typography variant="h6" style={{ fontWeight: 600, color: '#fff' }}>Post-Close Planning</Typography>
        </Box>
        <div style={{ padding: 40, textAlign: 'center' }}>
          <Typography variant="body1" color="textSecondary">{error}</Typography>
          <Button variant="outlined" onClick={() => history.push(`/bid-estimation/${projectId}`)}
            style={{ marginTop: 16, textTransform: 'none' }}>Back to Project</Button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: '#fafafa', minHeight: '100%' }}>
      <Box style={{ backgroundColor: '#2e7d32', color: '#fff', padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button size="small" startIcon={<ArrowBack />}
          onClick={() => history.push(`/bid-estimation/${projectId}`)}
          style={{ color: '#fff', textTransform: 'none' }}>Back</Button>
        <Typography variant="h6" style={{ fontWeight: 600, color: '#fff' }}>
          Post-Close Planning — {project?.name || ''}
        </Typography>
      </Box>

      <div style={{ padding: 20, maxWidth: 900 }}>
        {SECTIONS.map(sec => (
          <ChecklistCard
            key={sec.key}
            title={sec.title}
            items={planning?.[sec.key] || []}
            sectionKey={sec.key}
            projectId={projectId}
            url={url}
            onUpdate={handleUpdate}
          />
        ))}

        <KickoffCard
          projectId={projectId}
          kickoffMeeting={planning?.kickoffMeeting}
          url={url}
          onUpdate={handleUpdate}
        />

        <AspireHandoffCard
          projectId={projectId}
          project={project}
          aspireHandoff={planning?.aspireHandoff}
          url={url}
          onUpdate={handleUpdate}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
})

export default connect(mapStateToProps)(PostCloseView)
